import { ChevronBackwardIcon } from "@jti/brand-icons/chevron-backward";
import { Button } from "@jti/core-components/components/Button";

type BackButtonProps = {
  buttonLabel: string;
  onClick: () => void;
};

export const BackButton = ({ onClick, buttonLabel }: BackButtonProps) => (
  <Button
    variant="text"
    onClick={onClick}
    size="lg"
    data-testid="qrAgeVerificationBackButton"
    iconBefore={ChevronBackwardIcon}
  >
    {buttonLabel}
  </Button>
);
